import {
  Button,
  LanguageSwitcher,
  Logo,
  ModeToggle,
} from "@/shared/components";
import { CheckCircle2, MessageCircle, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useAuth } from "@features/auth/contexts/AuthContext";

function WaitingForActivationPage() {
  const { t, i18n } = useTranslation();
  const { logout, user } = useAuth();
  // determine short language code (en, fr, ar)
  const lang = (i18n?.language || "en").split("-")[0];

  const whatsappMessages = {
    en: `Hello, I have just signed up and I am waiting for your confirmation call.\n\nRegistered Information:\n• Name: ${
      user?.fullName ?? "N/A"
    }\n• Store Name: ${user?.brandName ?? "N/A"}\n• Phone: ${
      user?.phone ?? "N/A"
    }`,
    fr: `Bonjour, je viens de m'inscrire et j'attends votre appel de confirmation.\n\nInformations enregistrées:\n• Nom: ${
      user?.fullName ?? "N/A"
    }\n• Nom du magasin: ${user?.brandName ?? "N/A"}\n• Téléphone: ${
      user?.phone ?? "N/A"
    }`,
    ar: `مرحبا، لقد قمت بالتسجيل وأنا في انتظار مكالمة التأكيد منكم.\n\nالمعلومات المسجلة:\n• الاسم: ${
      user?.fullName ?? "غير متوفر"
    }\n• اسم المتجر: ${user?.brandName ?? "غير متوفر"}\n• الهاتف: ${
      user?.phone ?? "غير متوفر"
    }`,
  };

  const whatsappMessage = whatsappMessages[lang] ?? whatsappMessages.en;
  const whatsappHref = `https://wa.me/212660692400?text=${encodeURIComponent(
    whatsappMessage
  )}`;
  return (
    <main className="min-h-screen bg-gradient-to-br from-background to-muted flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Card Container */}
        <div className="bg-card rounded-lg shadow-lg p-8 md:p-12 text-center space-y-6">
          {/* Logo/Header */}
          <Logo className="h-20 mx-auto mb-8 mt-10" />
          <div className="flex items-center justify-center gap-4">
            <LanguageSwitcher />
            <ModeToggle />
          </div>

          {/* Success Icon */}
          <div className="flex justify-center">
            <div className="bg-green-500 rounded-full p-4 shadow-md">
              <CheckCircle2 className="w-12 h-12 text-white" />
            </div>
          </div>

          {/* Main Heading */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
              {t("waitingForActivation.title")}
            </h2>
            <p className="text-lg text-muted-foreground">
              {t("waitingForActivation.subtitle")}
            </p>
          </div>

          {/* Status Message */}
          <div className="bg-primary-50 border border-primary/50 rounded-lg p-4">
            <p className="text-primary font-semibold text-sm md:text-base">
              {t("waitingForActivation.statusMessage")}
            </p>
          </div>

          {/* Contact Section */}
          <div className="pt-4 space-y-3">
            <p className="text-muted-foreground text-sm mb-10">
              {t("waitingForActivation.urgentInquiries")}
            </p>
            <Button
              onClick={() =>
                window.open(whatsappHref, "_blank", "noopener,noreferrer")
              }
              className="group relative w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-6 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-1000 transform hover:scale-105 hover:animate-none"
              aria-label="Contact us on WhatsApp at 0660692400"
            >
              <span className="flex items-center justify-center gap-3">
                <span className="text-2xl animate-bounce">👉</span>

                <MessageCircle className="w-6 h-6 group-hover:rotate-12 transition-transform duration-300" />
                <span className="text-xl">WhatsApp: 0660692400</span>
                <span className="text-2xl animate-bounce">👈</span>
              </span>
            </Button>
          </div>

          {/* CTA Button */}
          <Button
            className="w-full bg-primary/90 hover:bg-primary text-primary-foreground font-semibold py-6 text-base rounded-lg transition-colors"
            onClick={() => (window.location.href = "https://www.skypostal.ma")}
          >
            {t("waitingForActivation.returnHome")}
          </Button>

          {/* Logout Button */}
          <Button
            className="w-full mt-3 border border-border text-foreground/80 font-semibold py-4 rounded-lg transition-colors bg-transparent hover:bg-muted/20"
            onClick={() => {
              logout();
              // window.location.href = "/login";
            }}
          >
            {t("waitingForActivation.logout")}
          </Button>

          {/* Footer Message */}
          {/* <div className="pt-4 border-t border-border">
            <p className="text-xs text-muted-foreground">
              {t("waitingForActivation.trustedBy")}
            </p>
          </div> */}
        </div>
      </div>
    </main>
  );
}

export default WaitingForActivationPage;
